<template>
    <div class="page-content page-content--wide">
        <CustomerSpecificCourses v-if="isLoggedIn && !isInSummitTimeRange" />
        <FeaturedCourses />
        <MostPopularLearningPaths />
        <Topics />
        <MostPopularCourses v-if="isLoggedIn === false && !isInSummitTimeRange" />
        <RecentlyAddedCourses v-if="!isInSummitTimeRange"/>
        <MostPopularCoursesInTopic v-if="isLoggedIn && !isInSummitTimeRange" />
        <UpcomingLiveEvents v-if="isLoggedIn && !isInSummitTimeRange" />
        <SignUpForDigitalClassrooms v-if="isLoggedIn && !isInSummitTimeRange" />
    </div>
</template>

<script>

    import FeaturedCourses from 'components/landingpage/recommended-items/FeaturedCourses'
    import Topics from 'components/landingpage/recommended-items/Topics'
    import MostPopularCourses from 'components/landingpage/recommended-items/MostPopularCourses'
    import MostPopularLearningPaths from 'components/landingpage/recommended-items/MostPopularLearningPaths'
    import { mapGetters } from 'vuex'
    import CustomerSpecificCourses from 'components/landingpage/recommended-items/CustomerSpecificCourses'
    import RecentlyAddedCourses from 'components/landingpage/recommended-items/RecentlyAddedCourses'
    import MostPopularCoursesInTopic from 'components/landingpage/recommended-items/MostPopularCoursesInTopic'
    import UpcomingLiveEvents from 'components/landingpage/recommended-items/UpcomingLiveEvents'
    import SignUpForDigitalClassrooms from 'components/landingpage/recommended-items/SignUpForDigitalClassrooms'
    import summitEventHelper from 'helpers/summitEventHelper'

    export default {
        components: {
            SignUpForDigitalClassrooms,
            UpcomingLiveEvents,
            MostPopularCoursesInTopic,
            RecentlyAddedCourses,
            CustomerSpecificCourses,
            MostPopularCourses,
            MostPopularLearningPaths,
            Topics,
            FeaturedCourses
        },
        mixins: [ summitEventHelper ],
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn'
            })
        }
    }
</script>
